
import React, { useState, useEffect, useRef } from "react";
import './LeftSidebar.css';
import { Link } from "react-router-dom";
import getMenuItems from "../components/MenuItems";
import getMenuItems_vat from "../components/Menu_item_vat";
import fetchData from "../functions/fetchData";


export default function LeftSidebar({ usertype, isOpen, isMobile, onClose }) {
  const [activeMenu, setActiveMenu] = useState(null);
  const [menuItems, setMenuItems] = useState([]);
  const [hoveredMenu, setHoveredMenu] = useState(null);
  const [sidebarHovered, setSidebarHovered] = useState(false);
  const sidebarRef = useRef(null);

  useEffect(() => {
    // Fetch tax_type from coresetting and set menu accordingly
    async function fetchTaxTypeAndMenu() {
    setMenuItems(getMenuItems_vat(usertype));
    }
    fetchTaxTypeAndMenu();
  }, [usertype]);

  const handleMenuClick = (index) => {
    setActiveMenu(activeMenu === index ? null : index);
  };

  // Handle menu link clicks for mobile
  const handleMenuLinkClick = (item) => {
    if (isMobile && !item.submenu) {
      // Close mobile sidebar when clicking a direct link
      onClose();
    }
  };

  // No submenu open/close on hover
  const handleMouseEnter = () => {};
  const handleMouseLeave = () => {};

  // Sidebar is considered open if isOpen or hovered while collapsed (desktop only)
  // For mobile, always show content when sidebar is open
  const effectiveOpen = isMobile ? isOpen : (isOpen || (!isMobile && !isOpen && sidebarHovered));

  return (
    <div
      ref={sidebarRef}
      className={`left-sidebar fixed-sidebar-left ${effectiveOpen ? "open" : "collapsed"} ${isMobile && isOpen ? "mobile-open" : ""}`}
      style={{
        overflowX: "hidden",
        minHeight: "100vh",
        width: isMobile ? 240 : (effectiveOpen ? 240 : 60),
        transition: isMobile ? 'left 0.3s ease' : 'width 0.2s',
        zIndex: 2000,
        position: 'fixed',
        left: isMobile ? (isOpen ? 0 : -240) : 0,
        boxShadow: isMobile && isOpen ? '2px 0 8px rgba(217,4,41,0.08)' : 'none',
        background: effectiveOpen ? 'linear-gradient(180deg, #d90429 0%, #222 100%)' : '#222',
        borderRight: effectiveOpen ? '4px solid #d90429' : 'none',
      }}
      onMouseEnter={() => { if (!isMobile && !isOpen) setSidebarHovered(true); }}
      onMouseLeave={() => { if (!isMobile && !isOpen) { setSidebarHovered(false); setHoveredMenu(null); } }}
    >
      <ul className="nav navbar-nav side-nav nicescroll-bar" style={{ overflowX: "hidden", paddingLeft: isMobile ? 0 : undefined }}>
        <li className="navigation-header" style={{ paddingLeft: isMobile ? 16 : undefined, color: '#fff', fontWeight: 700, letterSpacing: '1px' }}>
          <span>Main</span>
          <i className="zmdi zmdi-more" style={{ color: '#fff' }}></i>
        </li>

        {menuItems.map((item, index) => {
          const showSubmenu = (isMobile || effectiveOpen) && activeMenu === index;
          return (
            <li
              key={index}
              style={{ position: 'relative', paddingLeft: isMobile ? 8 : undefined, paddingRight: isMobile ? 8 : undefined }}
            >
              <Link
                to={item.submenu ? "#!" : item.path || "#!"}
                onClick={(e) => {
                  if (item.submenu) {
                    e.preventDefault();
                    handleMenuClick(index);
                  } else {
                    handleMenuLinkClick(item);
                  }
                }}
                data-toggle="collapse"
                data-target={item.dataTargetId}
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  padding: isMobile ? '10px 8px' : '10px 0',
                  fontSize: isMobile ? '15px' : '14px',
                  width: '100%',
                  minHeight: '40px',
                }}
              >
                <div style={{
                  width: 32,
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  marginRight: isMobile ? 12 : 20,
                }}>
                  <i className={`zmdi zmdi-${item.icon}`} style={{
                    fontSize: 22,
                    color: effectiveOpen ? '#fff' : '#d90429',
                  }}></i>
                </div>
                {(isMobile || effectiveOpen) && (
                  <span className="right-nav-text" style={{
                    opacity: 1,
                    fontWeight: 600,
                    color: effectiveOpen ? '#fff' : '#d90429',
                    flex: 1,
                    textAlign: 'left',
                    letterSpacing: '1px',
                  }}>
                    {item.name}
                  </span>
                )}
                {item.submenu && (isMobile || effectiveOpen) && (
                  <div style={{ marginLeft: 'auto' }}>
                    <i className={`zmdi zmdi-caret-${showSubmenu ? "up" : "down"}`}></i>
                  </div>
                )}
              </Link>
              {item.submenu && (
                <ul
                  className={`submenu ${showSubmenu ? "show" : ""}`}
                  style={{
                    background: effectiveOpen ? 'rgba(255,255,255,0.08)' : '#222',
                    paddingLeft: isMobile ? 34 : 54,
                    borderRadius: '10px',
                  }}
                >
                  {item.submenu.map((subItem, subIndex) => (
                    <li key={subIndex}>
                      <Link
                        to={subItem.path}
                        onClick={() => handleMenuLinkClick(subItem)}
                        style={{
                          fontSize: isMobile ? '14px' : '13px',
                          padding: isMobile ? '8px 0' : '6px 0',
                          color: effectiveOpen ? '#fff' : '#d90429',
                          display: 'block',
                          fontWeight: 500,
                        }}
                      >
                        {subItem.name}
                      </Link>
                    </li>
                  ))}
                </ul>
              )}
            </li>
          );
        })}

        <li className="navigation-header" style={{ paddingLeft: isMobile ? 16 : undefined }}>
          <span>Settings</span>
          <i className="zmdi zmdi-more" style={{ color: '#fff' }}></i>
        </li>
      </ul>
    </div>
// ...existing code...
  );
}
